export default __webpack_public_path__ + "static/31507-6c353a7ee04ed1bea7c545b05100e581.jpg";